import React, { useCallback, useState } from 'react'
import SendDoubt from 'components/SendDoubt'

import { AiOutlinePlus } from 'react-icons/ai'
import { MdDeleteForever } from 'react-icons/md'
import { toast } from 'react-toastify'

import {
  Wrapper,
  Container,
  AnnotationWrapper,
  AnnotationListWrapper,
  AddAnnotationWrapper,
} from './styles'

import AnnotationsFooterBar from '../AnnotationsFooterBar'
import { learningApi } from 'services/api'
import PDFRenderer from 'components/PDFRenderer'
import ModalConfirmation from 'components/ModalConfirmation'
import ModalFreemium from 'components/ModalFreemium'
import { WrapperContainer } from '../../../Course/components/ModuleAcordeon/styles'

import Direcao from 'assets/logos/direcao-square.png'
import { IoMdDownload } from 'react-icons/io'

import { useGetVideoAnnotations } from 'pages/Lesson/hooks/use-get-video-annotations'
import { TVideoAnnotation } from 'pages/Lesson/hooks/use-get-video-annotations/types'
interface AnnotationsProps {
  currentTime?: null | number
  courseId: string
  objectId: string
  lessonId: string
  moduleId: string
  videoId: string
  chapterId: string
  isText: boolean
  slide?: any
  courseName?: string
  moduleName?: string
  teacherId?: string
  teacherName?: string
  courseInfos: any
  moduleInfos: any
}

const Annotations: React.FC<AnnotationsProps> = ({
  currentTime,
  courseId,
  objectId,
  chapterId,
  lessonId,
  moduleId,
  videoId,
  isText,
  slide,
  courseName,
  moduleName,
  teacherId,
  teacherName,
  courseInfos,
  moduleInfos,
}) => {
  const [openModalDuvida, setModalDuvida] = useState(false)
  const [openModalFreemium, setOpenModalFreemium] = useState(false)
  const [annotationTime, setAnnotationTime] = useState('00:00')
  const [annotationType, setAnnotationType] = useState<'annotation' | 'doubt' | null>(null)
  const [showPDF, setShowPDF] = useState<boolean>(false)
  const [deleteAnnotationId, setDeleteAnnotationId] = useState('')
  const [openModal, setOpenModal] = useState<boolean>(false)
  const token = localStorage.getItem('token')

  const swrVideoAnnotations = useGetVideoAnnotations({ courseId, objectId })

  const annotations = swrVideoAnnotations.data

  const handleOpenModal = useCallback(() => {
    setModalDuvida(!openModalDuvida)
    setAnnotationType('annotation')
    setAnnotationTime(new Date(currentTime * 1000).toISOString().substr(14, 5))
  }, [currentTime, openModalDuvida])

  const handleModalDoubts = () => {
    setAnnotationType('doubt')
    setAnnotationTime(new Date(currentTime * 1000).toISOString().substr(14, 5))
    setModalDuvida(!openModalDuvida)
  }

  const handleDeleteNote = (annotationId: string) => {
    setDeleteAnnotationId(annotationId)
    setOpenModal(true)
  }

  const handleCloseModalConfirmation = async () => {
    setOpenModal(false)
  }

  const DeleteNote = async () => {
    await learningApi.delete(`/annotation/${deleteAnnotationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    toast.success('Item excluído com sucesso')

    swrVideoAnnotations.mutate()
  }

  const RenderModalFreemium = () => {
    const module = {
      _id: moduleInfos._id,
      name: moduleInfos.name,
      icon: courseInfos.icon ?? Direcao,
      discount: moduleInfos.discount,
      permanentLink: moduleInfos.permanentLink,
      qtd_videos: moduleInfos.total?.video?.amount,
      qtd_pdf: moduleInfos.total?.excerto?.amount,
    }

    const course = {
      _id: courseInfos._id,
      name: courseInfos.name,
      icon: courseInfos.icon ?? Direcao,
      discount: courseInfos.discount,
      permanentLink: courseInfos.permanentLink,
      qtd_videos: courseInfos.totalCourse.videos?.amount,
      qtd_pdf: courseInfos.totalCourse.excertos?.amount,
    }

    return (
      <WrapperContainer>
        <ModalFreemium
          module={module}
          course={course}
          setOpenModal={setOpenModalFreemium}
          subscription={courseInfos?.isFreemium && courseInfos?.isSubscription}
        />
      </WrapperContainer>
    )
  }

  const handleDownload = async () => {
    const url = slide.url
    const fileName = slide.name

    try {
      const userAgent = window.navigator.userAgent.toLowerCase()

      // Verifica se o usuário está no iOS
      if (/iphone|ipad|ipod/.test(userAgent)) {
        window.open(url, '_blank')
      } else {
        const response = await fetch(url)
        const blob = await response.blob()
        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    } catch (error) {
      console.error('Erro ao fazer o download:', error)
    }
  }

  const renderAnnotation = (annotation: TVideoAnnotation) => (
    <AnnotationWrapper key={annotation._id} className="line-note">
      <span>{annotation.duration}</span>
      <p>{annotation.note}</p>
      <button className="bin" onClick={() => handleDeleteNote(annotation._id)}>
        <MdDeleteForever size="20" />
      </button>
    </AnnotationWrapper>
  )

  return (
    <Wrapper>
      <Container>
        <div>
          <div className="texts">
            <h3>{showPDF ? 'Apresentação' : 'Anotações'}</h3>
            {showPDF && (
              <h4>
                <button onClick={handleDownload}>
                  <IoMdDownload size={16} />
                </button>
              </h4>
            )}
            <AnnotationsFooterBar
              havePDF={slide && slide.url}
              handleModalDoubts={handleModalDoubts}
              setShowPDF={setShowPDF}
              showPDF={showPDF}
              openModalDuvida={openModalDuvida}
            />
          </div>
        </div>
        {!showPDF && (
          <div>
            <AnnotationListWrapper>{annotations.map(renderAnnotation)}</AnnotationListWrapper>
            <AddAnnotationWrapper>
              <input
                disabled
                placeholder={`Criar uma nova anotação em ${new Date(currentTime * 1000)
                  .toISOString()
                  .substr(14, 5)}`}
              />
              <button className="plus-button" onClick={handleOpenModal}>
                <AiOutlinePlus />
              </button>
            </AddAnnotationWrapper>
          </div>
        )}
        {openModalDuvida ? (
          <SendDoubt
            teacherName={teacherName}
            courseName={courseName}
            moduleName={moduleName}
            type={annotationType}
            title={annotationType === 'doubt' ? 'Enviar dúvida' : 'Escreva sua anotação'}
            text={`${
              annotationType === 'doubt' ? 'Enviar uma dúvida' : 'Criar uma anotação'
            } em ${annotationTime}`}
            close={() => setModalDuvida(false)}
            annotationTime={annotationTime}
            refetchAnnotations={swrVideoAnnotations.mutate}
            courseId={courseId}
            moduleId={moduleId}
            videoId={videoId}
            lessonId={lessonId}
            chapterId={chapterId}
            objectId={objectId}
            isText={isText}
            teacher={teacherId}
            setOpenModalFreemium={setOpenModalFreemium}
            isFreemium={courseInfos?.isFreemium}
          />
        ) : null}
        {showPDF && <PDFRenderer url={slide.url} />}
      </Container>
      <ModalConfirmation
        open={openModal}
        setAnswer={DeleteNote}
        handleCloseModal={handleCloseModalConfirmation}
      />
      {openModalFreemium && RenderModalFreemium()}
    </Wrapper>
  )
}

export default Annotations
